import Vue from 'vue';
import Router from 'vue-router';

import isEmpty from 'lodash/isEmpty';

import store from '@/store/store';

import constants from '@/constants';

import AuthorisationUtil from '@/util/authorisation-util';

import Approvals from '@/views/approvals/Approvals.vue';
import ApproverClocking from '@/views/approvals/ApproverClocking.vue';
import Clock from '@/views/employee/Clock.vue';
import Employee from '@/views/employee/Employee.vue';
import EmployeeTimePairs from '@/views/employee/EmployeeTimePairs.vue';
import EmployeeWorkSchedules from '@/views/employee/EmployeeWorkSchedules.vue';
import Login from '@/views/Login.vue';
import Settings from '@/views/Settings.vue';
import ApproverWorkSchedules from '@/views/approvals/ApproverWorkSchedules.vue';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      name: 'Login',
      path: '/login',
      component: Login,
      props: true,
    },
    {
      name: 'Approvals',
      path: '/approvals',
      component: Approvals,
      beforeEnter: (to, from, next) => {
        if (AuthorisationUtil.isManager()) next();
        else next(false);
      },
    },
    {
      name: 'ApproverClocking',
      path: '/approver-clocking',
      component: ApproverClocking,
      beforeEnter: (to, from, next) => {
        if (AuthorisationUtil.managerCanClockEmployees()) {
          next();
        } else {
          next(false);
        }
      },
    },
    {
      name: 'ApproverWorkSchedules',
      path: '/approver-work-schedules',
      component: ApproverWorkSchedules,
    },
    {
      name: 'Settings',
      path: '/settings',
      component: Settings,
    },
    {
      path: '/time',
      component: Employee,
      beforeEnter: (to, from, next) => {
        if (AuthorisationUtil.employeeHasViewTimeAuthority()
          || AuthorisationUtil.employeeHasCaptureTimeAuthority()) {
          next();
        } else {
          next(false);
        }
      },
      children: [
        {
          name: 'Clock',
          path: 'clock',
          component: Clock,
        },
        {
          name: 'EmployeeTimePairs',
          path: 'time-pairs',
          component: EmployeeTimePairs,
        },
      ],
    },
    {
      name: 'EmployeeWorkSchedules',
      path: '/employee-work-schedules',
      component: EmployeeWorkSchedules,
    },
    {
      path: '*',
      beforeEnter(to, from, next) {
        next(false);
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.params.logout && AuthorisationUtil.getAuthToken()) {
    AuthorisationUtil.destroyJwt();
    store.replaceState(constants.DefaultState());

    next({ params: { logout: true } });
  } else if (isEmpty(store.state.employee)) {
    const authToken = AuthorisationUtil.fetchDecodedAuthToken();

    if (authToken) {
      store.state.profileLoading = true;
      store.dispatch('fetchUserProfile', authToken)
      .then(() => {
        store.state.profileLoading = false;
        if (
          to.path === '/'
          || to.name === 'Login'
        ) {
          if (AuthorisationUtil.isManager()) {
            next({ name: 'Approvals' });
          } else {
            next({ name: 'Clock' });
          }
        } else {
          next({ name: to.name });
        }
      });
    } else {
      AuthorisationUtil.destroyJwt();
      store.replaceState(constants.DefaultState());

      window.location.href = '/saml/login';
    }
  } else {
    next();
  }
});

export default router;
